// Archive (past daily games) support: per-game localStorage and game id <-> date mapping.
// Kept separate from the "game" key so playing an old game never touches today's saved game.
import {scoreLevel} from '../util/definitions.mjs';
var ls = require('local-storage');

// oldest game id with an unbroken run of daily games up to today
export const FIRST_ARCHIVE_GAME = 2000;
// in-progress archive boards kept; the least recently played is dropped beyond this
const MAX_ARCHIVE_IN_PROGRESS = 10;
const DAY_MS = 24 * 60 * 60 * 1000;

// games roll over at midnight Pacific, so "today" is the Pacific date
export function pacificToday(now = new Date()) {
  const [y, m, d] = new Intl.DateTimeFormat('en-CA', {timeZone: 'America/Los_Angeles'}).format(now).split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

// approximate release date of a game (one game per day ending at the current game)
export function gameDate(gameId, currentGameId, today) {
  return new Date(today.getTime() - (Number(currentGameId) - Number(gameId)) * DAY_MS);
}

// game id released on a date, or null if outside the archive
export function gameForDate(date, currentGameId, today) {
  const id = Number(currentGameId) - Math.round((today.getTime() - date.getTime()) / DAY_MS);
  if ( id < FIRST_ARCHIVE_GAME || id > Number(currentGameId) )
    return null;
  return id;
}

// completed games (daily and archive): {id: {score, medal}}, keeping the best score
export function getGameResults() {
  return ls.get("gameResults") || {};
}

export function recordGameResult(gameId, goalScore, score) {
  let results = getGameResults();
  let prev = results[gameId];
  if ( !prev || score > prev.score ) {
    results[gameId] = {score: score, medal: scoreLevel(goalScore, score)};
    ls.set("gameResults", results);
  }
}

// in-progress archive boards: {id: state}
export function getArchiveState(gameId) {
  let games = ls.get("archiveGames") || {};
  return games[gameId] || null;
}

export function getArchiveInProgress() {
  return ls.get("archiveGames") || {};
}

export function saveArchiveState(state) {
  let games = ls.get("archiveGames") || {};
  if ( state.gameover ) {
    recordGameResult(state.game, state.goalScore, state.score);
    delete games[state.game];
  }
  else {
    games[state.game] = {...JSON.parse(JSON.stringify(state)), saved: Date.now()};
    let ids = Object.keys(games);
    if ( ids.length > MAX_ARCHIVE_IN_PROGRESS ) {
      ids.sort((a, b) => games[a].saved - games[b].saved);
      delete games[ids[0]];
    }
  }
  ls.set("archiveGames", games);
}
